import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router';
import routes from './router/routes';
import store from './store/store';
import './css/ol3-sidebar.css';
import './css/ol3-sidebar-custom.css';
import VueGtag from 'vue-gtag';
import Hotjar from 'vue-hotjar';
import moment from "moment";
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.config.productionTip = false;

let isInitialRoute = true;

Vue.mixin({
  computed: {
      console: () => console
  }
});

router.beforeEach((to, from, next) => {

  if (isInitialRoute) {
    isInitialRoute = false

    // To invalidate user logged in with another authenticator (another internal api)
    if (!store.getters.currentUser || !store.getters.currentUser.attributes) {
      store.dispatch('logOut');
      next({ path: routes.weather.path, replace: true });
    }

  }

  if (!isInitialRoute) {

    if (to.matched.some(record => record.meta.bothGuestAuth)) {
      next();
    }
    else if (to.matched.some(record => record.meta.requiresAuth)) {

      if(store.getters.loggedIn){
        const { authorize } = to.meta;
        const { roles } = store.getters.currentUser.attributes;
        const listRoles = Array.isArray(roles) ? roles : [roles];
        const errorMessage = "Você não tem autorização para visualizar esta página."

        if (!listRoles.some(r => authorize.includes(r))) {
          next({ name: routes.responseError.name, replace: true, params: { message: errorMessage, status: 403 } })
        }
        else {
          next({});
        }
      }
      else{
        next({ path: routes.weather.path, replace: true });
      }
    }
    else {
      if (store.getters.loggedIn) {
        next({ path: routes.home.path, replace: true });
      }
      else {
        next();
      }
    }

    if (store.getters.currentUser && store.getters.loggedIn) {
      verifyUserSessionTimeOut();
    }
  }
});

function verifyUserSessionTimeOut(){
  let seconds = store.getters.currentUser.attributes.expires_in;
  let timestamp =  store.getters.currentUser.attributes.timestamp;
  let now = moment().format('YYYY-MM-DD HH:mm:ss');
  if(seconds && timestamp && now) {
    let diff;
    diff = moment(now, 'YYYY-MM-DD HH:mm:ss').diff(moment(timestamp, 'YYYY-MM-DD HH:mm:ss'), 'seconds');
    if (diff >= seconds) {
      store.dispatch('logOut');
      router.push(routes.weather.path);
    }
  }
}

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID },
}, router)

Vue.use (Hotjar, {
  id: process.env.VUE_APP_HOTJAR_ID ,
  isProduction: process.env.NODE_ENV === 'production' ? true : false,
  snippetVersion: 6
})

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_CLIENT,
  loaderOptions:{ autoHideBadge: true }
})

new Vue({
  store,
  router,
  routesss: routes,
  vuetify,
  render: h => h(App)
}).$mount('#app')
